import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetNotificationSlice = createSlice({
    name: "getNotification",
    initialState,
    reducers: {
        getNotificationRequest(state) {
            state.loading = true;
        },
        getNotificationRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getNotificationRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getNotificationRequest,
    getNotificationRequestSuccess,
    getNotificationRequestError,
} = GetNotificationSlice.actions;

export default GetNotificationSlice.reducer;
